import { Layout, Menu, Tooltip } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { UserContext } from "../../App";

import logo from "../../Assets/Images/Logo.svg";
import pp from "../../Assets/Images/profilepicture.svg";
import settingIcon from "../../Assets/Icons/Settings.svg";
import customerLogo from "../../Assets/Icons/customer manage.svg"

import monitorLogo from "../../Assets/Icons/Monitoring.svg";
import monitorLogoSelected from "../../Assets/Icons/Monitoring active.svg";

import "./style.css";

const { Sider } = Layout;

const Sidebar = ({ breakpoint = null }) => {
  const { userData, setUserData, setUserToken } = useContext(UserContext);
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("null");
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname.includes("/all-users")) {
      setSelectedKey("1");
    } else if (pathname.includes("/recovery-company")) {
      setSelectedKey("2");
    } else if (pathname.includes("/theft-history")) {
      setSelectedKey("3");
    } else if (pathname.includes("/api-accounts")) {
      setSelectedKey("4");
    } else if (pathname.includes("/system-configuration")) {
      setSelectedKey("5");
    }
  }, [location.pathname]);

  const goToSettings = () => {
    navigate("/settings");
  };

  const items = [
    {
      key: "group",
      icon: (
        <img
          src={
            ["1", "2", "3", "4"].includes(selectedKey)
              ? monitorLogoSelected
              : monitorLogo
          }
          alt="monitorLogo"
        />
      ),
      label: "Management",
      children: [
        { key: "1", label: <Link to="/all-users">All Users</Link> },
        {
          key: "2",
          label: (
            <Tooltip placement="right" title="Recovery Company">
              <Link to="/recovery-company">Recovery Company</Link>
            </Tooltip>
          ),
        },
        // { key: "3", label: <Link to="/theft-history">Theft History</Link> },
        { key: "4", label: <Link to="/api-accounts">API Accounts</Link> },
        {
          key: "5",
          label: (
            <Tooltip placement="right" title="Sytem Configuration">
              <Link to="/system-configuration">System Configuration</Link>
            </Tooltip>
          ),
        },
      ],
    },
  ];

  return (
    <div className="sidebar">
      <Sider
        width={225}
        theme="light"
        collapsible
        collapsed={collapsed}
        onCollapse={(val) => setCollapsed(val)}
        breakpoint={breakpoint}
        collapsedWidth="0"
        style={{ height: "100vh", position: "fixed" }}
      >
        <div className="wrapper">
          <div className="logo-container">
            <img src={logo} alt="logo" />
          </div>

          <div className="ant-menu">
            <div className="menu-heading">All Pages</div>
            <Menu
              mode="inline"
              theme="light"
              selectedKeys={[selectedKey]}
              defaultOpenKeys={["group"]}
              items={items}
            />
          </div>
        </div>

        <div className="logout-div">
          <div className="logout-user">
            <div className="compact-avatar">
              <img
                className="profile-pic"
                src={
                  userData?.profile_picture
                    ? `${process.env.REACT_APP_MEDIA_URL}${userData.profile_picture}`
                    : customerLogo
                }
                alt="user-icon"
              />
            </div>
            <div className="logout-user-details">
              <div className="role">{userData?.name}</div>
              <span title="Example@company.com" className="email">
                {userData?.email}
              </span>
            </div>
            <div className="logout-icon" style={{ cursor: "pointer" }}>
              <img
                src={settingIcon}
                alt="setting Icon"
                onClick={goToSettings}
              />
            </div>
          </div>
        </div>
      </Sider>
    </div>
  );
};

export default Sidebar;
